import React from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaPhone, FaUser } from 'react-icons/fa';
import { useTranslation } from 'i18n/TranslationProvider';

const DriverCard = ({ driver, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const cardBg = useColorModeValue(
    'rgba(255, 255, 255, 0.82)',
    'rgba(14, 24, 54, 0.78)',
  );
  const cardBorder = useColorModeValue(
    'rgba(255, 255, 255, 0.95)',
    'rgba(255, 255, 255, 0.12)',
  );
  const titleColor = useColorModeValue('navy.700', 'white');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const chipBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.100');

  return (
    <Box
      p={{ base: 4, md: 5 }}
      borderWidth="1px"
      borderColor={cardBorder}
      borderRadius="18px"
      bg={cardBg}
      backdropFilter="blur(6px)"
      boxShadow="0 18px 36px rgba(12, 28, 70, 0.12)"
      w="100%"
    >
      <Flex
        direction={{ base: 'column', xl: 'row' }}
        align={{ base: 'stretch', xl: 'center' }}
        justify="space-between"
        gap={4}
      >
        <HStack spacing={3} minW={{ xl: '240px' }}>
          <Flex
            w={10}
            h={10}
            borderRadius="12px"
            bg={chipBg}
            align="center"
            justify="center"
          >
            <Icon as={FaUser} width="16px" height="16px" color="blue.400" />
          </Flex>
          <Text fontWeight="700" fontSize={{ base: 'md', md: 'lg' }} color={titleColor}>
            {driver.firstName} {driver.lastName}
          </Text>
        </HStack>

        <HStack
          flexWrap="wrap"
          spacing={2.5}
          align="center"
          justify={{ base: 'flex-start', xl: 'center' }}
        >
          <HStack px={3} py={1.5} borderRadius="12px" bg={chipBg}>
            <Icon as={FaPhone} color={textColor} />
            <Text color={textColor} fontSize="sm">
              {driver.phone ? driver.phone : t('No phone')}
            </Text>
          </HStack>
        </HStack>

        <HStack
          justify={{ base: 'stretch', md: 'flex-end' }}
          spacing={2}
          w={{ base: '100%', md: 'auto' }}
        >
          <Button
            size="sm"
            variant="outline"
            onClick={() => onEdit(driver)}
            px={4}
            w={{ base: '100%', md: 'auto' }}
          >
            {t('Edit')}
          </Button>
          <Button
            size="sm"
            colorScheme="red"
            px={4}
            onClick={() => onDelete(driver._id)}
            w={{ base: '100%', md: 'auto' }}
          >
            {t('Delete')}
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default DriverCard;
